import React from 'react'
import styles from '../../index.module.css'

export interface PbButtonProps{
    onClick: () => any,
    label: string,
    variant?: 'primary' | 'secondary'
}

export default function PbButton(props: PbButtonProps){
    const onKeyUp = async (e: any) => {
        if (e.keyCode === 13)
          await props.onClick();
      }
    
    return <div className={props.variant === 'secondary' ? styles.buttonSecondary : styles.button}
        role='button'
        tabIndex={0}
        onClick={props.onClick}
        onKeyUp={onKeyUp}
    >
    {props.label}
  </div>
}
